<button [ngStyle]="{'width': inputWidth ? inputWidth : ''}" (click)="( null); emitClick.emit()" class="app-button gap-8 {{classes}}" [class.button--disabled]="disabled" [class.button--submitting]="submitting">
    <span>{{text}}</span>
    @if (icon) {
        <i class="icon {{icon}}" [ngStyle]="{'width' : iconSize, 'height': iconSize }"></i>
    }
</button>